export default class DtoPond {
    constructor(obj) {
        this.stationId = obj.stationId
        this.gridType = obj.gridType
        this.coords = obj.coords
        this.area = obj.area
        this.pond = obj.pond
    }
}